<template>
    <div class="x-postcontent x-postcontent-0 clearfix">
        <div class="x-content-layout layout-item-0">
            <div class="x-content-layout-row">
                <div
                    class="x-layout-cell layout-item-1"
                    style="width: 100%"
                    >
                    <table class="x-article" style="width: 100%; ">
                        <tbody>
                            <tr>
                                <td style="width: 100%; ">
                                    <h1 class="header">Taxinummer en de media</h1>
                                    <br /><br />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                    <tbody>
                        <tr>
                            <td style="width: 100%; ">
                                <h1></h1>
                                <br />
                            </td>
                        </tr>
                    </tbody>
                    </table>
                    <h2>YOUTUBE</h2>
                    <div class="col-group">
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/B9lNlpNmgzM" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/MVBQ57j88Zk" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/yM-YXY4rdCM" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/SxlrjKXDJNs" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/1rhIHkQh3vA" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/C5wmmfiMWSk" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/GZubyzuSp_Y" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/HiHYNFt2Tig" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/1GTFOJkwZ4w" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/L_2tcgEA1Pc" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen/>
                            </div>
                        </div>
                        <div class="col-md-12 col-6 ratio-box">
                            <div class="ratio-content media-video">
                                <iframe 
                                    class="embeded-video"
                                    src="https://www.youtube.com/embed/hSkR-CH2cF4" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.media-video{
    padding: 15px;
}
</style>

<script>
// @ is an alias to /src

    export default {
        name: 'home',
    }
</script>
